<div class="container-fluid p-3">
  <!-- Formulario de Garantizados -->
  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} Garantizado de Vendedor</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="garantizadoForm" (ngSubmit)="onSubmit()">
        <div class="row g-3 align-items-center">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="outline" class="w-100"
              [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''"
              [matTooltipPosition]="'above'" [matTooltipDisabled]="!isEditing">
              <mat-label>Vendedor</mat-label>
              <input type="text" matInput [formControl]="vendedorControl" [matAutocomplete]="auto"
                [attr.disabled]="isEditing ? '' : null" placeholder="Buscar por código o nombre">
              <button mat-icon-button matSuffix (click)="mostrarTodosLosVendedores()" type="button"
                [disabled]="isEditing">
                <mat-icon>search</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayVendedor">
                <mat-option *ngFor="let vendedor of vendedoresFiltrados | async" [value]="vendedor">
                  {{vendedor.codigo_vendedor}} - {{vendedor.nombre_vendedor}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="garantizadoForm.get('c_vend')?.hasError('required')">
                El vendedor es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha Inicio</mat-label>
              <input matInput [matDatepicker]="pickerInicio" formControlName="fecha_inicio" required>
              <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker #pickerInicio></mat-datepicker>
              <mat-error *ngIf="garantizadoForm.get('fecha_inicio')?.hasError('required')">
                La fecha de inicio es requerida
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha Fin</mat-label>
              <input matInput [matDatepicker]="pickerFin" formControlName="fecha_fin" required>
              <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
              <mat-datepicker #pickerFin></mat-datepicker>
              <mat-error *ngIf="garantizadoForm.get('fecha_fin')?.hasError('required')">
                La fecha fin es requerida
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor Garantizado</mat-label>
              <input matInput type="text" formControlName="valor_garantizado" required
                [value]="garantizadoForm.get('valor_garantizado')?.value | currency:'COP':'symbol-narrow':'1.0-0'"
                (input)="onValorGarantizadoInput($event)">
              <mat-error *ngIf="garantizadoForm.get('valor_garantizado')?.hasError('required')">
                El valor garantizado es requerido
              </mat-error>
              <mat-error *ngIf="garantizadoForm.get('valor_garantizado')?.hasError('min')">
                El valor debe ser mayor a 0
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit" [disabled]="!garantizadoForm.valid || isLoading"
            class="btn btn-primary">
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span *ngIf="!isLoading">{{ isEditing ? 'Actualizar' : 'Guardar' }}</span>
          </button>
          <button mat-flat-button type="button" (click)="onCancel()" *ngIf="isEditing" [disabled]="isLoading"
            class="btn btn-secondary">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Garantizados de Vendedor</mat-card-title>
    </mat-card-header>

    <mat-card-content class="pt-3">
      <!-- Barra de búsqueda -->
      <div class="row mb-3">
        <div class="col-md-4 col-sm-12 mb-2 mb-sm-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Buscar por vendedor...">
            <mat-icon matSuffix class="text-dark">search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table w-100">
          <ng-container matColumnDef="codigo_vendedor">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;font-size: 11px;">Código</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.codigo_vendedor}}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombre_vendedor">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;font-size: 11px;">Nombre</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.nombre_vendedor}}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_inicio">
            <th mat-header-cell *matHeaderCellDef style="width: 15%;font-size: 11px;">Fecha Inicio</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.fecha_inicio | date:'dd/MM/yyyy'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_fin">
            <th mat-header-cell *matHeaderCellDef style="width: 15%;font-size: 11px;">Fecha Fin</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.fecha_fin | date:'dd/MM/yyyy'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="valor_garantizado">
            <th mat-header-cell *matHeaderCellDef style="width: 15%;font-size: 11px;">Valor Garantizado</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.valor_garantizado | currency:'COP':'symbol-narrow':'1.0-0'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 15%;font-size: 11px;" class="text-center">Acciones</th>
            <td mat-cell *matCellDef="let element" class="text-center" style="vertical-align: middle;">
              <div style="display: flex; justify-content: center; gap: 4px;">
                <button mat-icon-button color="primary" (click)="onEdit(element)" matTooltip="Editar">
                  <mat-icon class="text-dark">edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="onDelete(element)" matTooltip="Eliminar">
                  <mat-icon class="text-dark">delete</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="verDetalles(element)" matTooltip="Ver Detalles">
                  <mat-icon class="text-dark">info</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row para cuando no hay datos -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6" style="text-align: center;">
              No se encontraron registros
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>